<template>
	 <v-container>
		 <v-dialog title="修改课时有效期" v-model="hideShow" width="500px" persistent>
			<v-card>
				<v-card-title>
					<span>修改课时有效期</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-5">
					
					<v-row dense v-if="account" class="mt-5">
						<v-col cols="6">
							<v-text-field label="学员姓名" v-model="account.studentName" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="课程名称" v-model="account.courseName" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="课时余额" v-model="account.balanceHour" disabled dense outlined></v-text-field>
						</v-col>
						<v-col cols="6">
							<v-text-field label="金额余额" v-model="account.balanceFee" disabled dense outlined></v-text-field>
						</v-col>
						
						<v-col cols="12" class="mt-n6">
							<v-text-field label="原有效期" disabled v-model="account.expireDate" dense outlined></v-text-field>
							<v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								transition="scale-transition" offset-y min-width="auto">
								<template v-slot:activator="{ on, attrs }">
									<v-text-field v-model="form.expireDate" label="新有效期" readonly v-bind="attrs" v-on="on"
										dense clearable outlined></v-text-field>
								</template>
								<v-date-picker v-model="form.expireDate" @input="menu1=false" no-title scrollable locale="zh-cn">
								</v-date-picker>
							</v-menu>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn @click="cancel">取消</v-btn>
					<v-btn @click="submitForm" :disabled="form.submitting" :loading="form.submitting" color="primary">确定</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	 </v-container>
</template>

<script>
	import utils from "../config/utils"
	export default {
		name:"edit-account-expire",
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			account:{
				type:Object,
				default:null
			}
		},
		watch:{
			show(newVal,oldVal){
			
				this.hideShow = newVal;
				if(this.hideShow){
					this.form.expireDate = "";		
				}
			}
		},
		data(){
			return {
				menu1:false,
				shopId:"",
				hideShow:this.show,
				currentCourseId:"",
				form:{
					submitting:false,
					expireDate:"" , 
				},
			}
		},
		
		mounted() {
			console.log("mounted");
			this.shopId = utils.getCurrentShopId();
		},
		methods:{
			cancel(){
				this.$emit("cancel","");
			},
			
			submitForm(){
				
				this.form.submitting = true;
				
				if(!this.form.expireDate){
					this.$noty.error('有效期不能为空');
					return
				}
				
				// api
				const that = this;
				let url = `/financial/course/account/expire/${this.account.id}/${this.form.expireDate}`;
					
				this.axios.post(url).catch(() => {
					that.form.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("修改成功");
							
							that.form.submitting = false;
							that.$emit("success","");
							return;
						} else {
							that.form.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.form.submitting = false;
						that.$noty.error('网络请求失败');
					}
							
				});
			},
			
		}
	}
	
</script>

<style>
</style>
